import React from "react";
import {
  ErrorMessageContainer,
  ErrorText,
  FieldErrorIconContainer,
} from "./errorMessage.styles";
import { FieldErrorIcon } from "../../icons";
import { useMediaQuery } from "@mui/material";

interface ErrorMessageProps {
  errorMessage?: string;
  radiusStyle?: boolean;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  errorMessage = "",
  radiusStyle,
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <ErrorMessageContainer radiusStyle={radiusStyle}>
      <FieldErrorIconContainer>
        <FieldErrorIcon size={isMobile ? "middle" : "large"} className="" />
      </FieldErrorIconContainer>
      <ErrorText>{errorMessage}</ErrorText>
    </ErrorMessageContainer>
  );
};

export default ErrorMessage;
